import type { BpaRowFormValues } from "../schemas/manageFormSchemas";

export type AssignmentField = "assignedResearcherId" | "assignedEditorId";

export function applyBulkAssignment(
  rows: BpaRowFormValues[],
  selected: Set<string>,
  field: AssignmentField,
  value: string | null,
): BpaRowFormValues[] {
  return rows.map(row => (selected.has(row.id) ? { ...row, [field]: value } : row));
}
